import type React from 'react';

/** What every list cell shows for a field with no value (Shaun, 2026-10-15) - as Group Chat always has. */
export const EMPTY_CELL = '-';

/** A cell's text as its tooltip - none for an empty cell, whose dash says nothing more on hover. */
export const cellTitle = (text: string | null | undefined): string | undefined => (text && text !== EMPTY_CELL ? text : undefined);

// Whether any part of the cell has its text cut off: a box that clips (overflow hidden, as Tailwind's truncate is)
// holding more than it shows.
const isCut = (cell: HTMLElement) =>
  [cell, ...Array.from(cell.querySelectorAll<HTMLElement>('*'))].some(el =>
    getComputedStyle(el).overflow !== 'visible' && el.scrollWidth > el.clientWidth + 1);

/**
 * A cell's tooltip, only when it tells you something (Shaun, 2026-10-15): the text is cut off with "...", or `addsMore`
 * - it says more than the cell shows, as a tiered status's full path does. Decided on hover, because whether text fits
 * depends on the column's width at that moment; a tooltip repeating text that is all on screen is noise.
 */
export const hoverTitle = (text: string | null | undefined, addsMore = false) => ({
  onMouseEnter: (event: React.MouseEvent<HTMLElement>) => {
    const cell = event.currentTarget;
    const title = cellTitle(text);
    if (title && (addsMore || isCut(cell))) cell.title = title;
    else cell.removeAttribute('title');
  },
});
